// eslint-disable-next-line import/prefer-default-export
export const getSortedItems = (items, orderBy) => {
  const [orderConfig] = Object.keys(orderBy);
  const sorted = items || [];
  if (sorted && Array.isArray(sorted) && orderConfig) {
    sorted.sort((a, b) => (a[orderConfig] > b[orderConfig] ? 1 : -1));

    if (orderBy[orderConfig] === 'desc') {
      sorted.reverse();
    }
  }
  return items;
};
